import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./register.css";
import "./login.css";
import Logo from "@/assets/imgs/logo.png";
import email_icon from "@/assets/imgs/email_component.png";
import toast from "react-hot-toast";

import { useSendLinkRecoveryPass } from "@/hooks/useAuth";

export const ForgotPassword = () => {
  const navigate = useNavigate();
  const sendLink = useSendLinkRecoveryPass();
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isButtonActive = email.trim() !== "" && !isSubmitting;

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const onSubmit = () => {
    if (!isButtonActive) { // Evita ejecuciones si el botón ya está deshabilitado
      return;
    }
    setIsSubmitting(true); 
    const formData = {
      usuario_correo: email,
      usuariotipo_id: 2,
    };

    sendLink
      .mutateAsync(formData)
      .then(() => {
        toast.success("Si el correo está registrado, te enviaremos un enlace para restablecer tu contraseña.");
        navigate("/login");
      })
      .catch((error) => {
        toast.error(error);
      })
      .finally(() => {
        setIsSubmitting(false); // Habilita el botón de nuevo al finalizar (éxito o error)
      });
  };

  return (
    <div className="login-container">
      <div className="login-left-image" />
      <div className="login-form-container">
        <img src={Logo} alt="Openmatic Logo" className="login-logo" />
        <h2 className="register-welcome">¿Olvidaste tu contraseña?</h2>
        <h3 className="register-title2">Recupérala por correo</h3>
        <p className="register-subtitle">
          Enviaremos un mensaje a tu correo para que puedas restablecer tu
          contraseña
        </p>
        <form>
          <div className="input-icon-wrapper">
            <img src={email_icon} alt="check" className="input-icon" />
            <input
              type="email"
              value={email}
              onChange={handleChange}
              placeholder="Correo"
              className="input-with-icon"
              required
            />
          </div>

          {/* {email != "" ? (
            <button className="register-button" style={{backgroundColor:"#A0C31E"}} type="button"  onClick={onSubmit}>
              Enviar
            </button>
          ) : (
            <button className="register-button" type="button"   disabled>
              Enviar
            </button>
          )} */}
           <button
        className={`register-button-active ${isButtonActive ? 'register-button' : ''}`}
        type="button"
        onClick={onSubmit}
        disabled={!isButtonActive} // El botón se deshabilita si isButtonActive es false
      >
        {isSubmitting ? 'Enviando...' : 'Enviar'} {/* Cambia el texto del botón durante el envío */}
      </button>
        </form>
      </div>
    </div>
  );
};
